import axios from 'axios';
import apiConfig from '../api.config';

export default function updatePoliceERTZ({
  hotelId,
  ertzCredentials,
  lessorCode,
  establishmentCode,
}) {
  const {
    host,
    URIs: { policeReport, policeReportERTZ },
  } = apiConfig;

  const uri = `${host}${policeReport}/${policeReportERTZ.replace(':hotelId', hotelId)}`;

  return axios
    .put(uri, JSON.stringify(ertzCredentials, lessorCode, establishmentCode), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
